import controleAcessoSol from './controleacesso/rotas';
import solucaoRoute from './solucao/rotas';
import vitrineRoute from './vitrine/rotas';
import relatorioRoute from './relatorio/rotas';

const routes = {
    path: 'sol',
    name: 'Sol',
    component: () => import('./Sol.vue'),
    meta: {
        rules: [
            ...controleAcessoSol.meta.rules,
            ...solucaoRoute.meta.rules,
            ...vitrineRoute.meta.rules,
            ...relatorioRoute.meta.rules,
        ],
    },
    children: [
        controleAcessoSol,
        solucaoRoute,
        vitrineRoute,
        relatorioRoute,
    ],
};

export default routes;
